import apiHandler from "../core/apiHandler";

const cashIncomeApi = apiHandler("cash/incomes");

export default cashIncomeApi;